import ComponentManager from "../../componentFramework";
import JsfAjaxScrollImprovements from "../../scripts/jsf/JsfAjaxScrollImprovements";
import PanelLayout from "../PanelLayout";

/**
 * Uses JsfAjaxScrollImprovements to make the search results retain scroll position
 * after an AJAX update and/or ensure a selected item is in view.
 */
@ComponentManager.register()
export default class SearchResults {
	public static componentStyleClass = "searchResults";
	private jsfAjaxScrollImprovements: JsfAjaxScrollImprovements | undefined;

	constructor(private readonly rootElement: HTMLElement) {}

	@ComponentManager.on("ready")
	protected componentReady() {
		const resultsList = this.getSearchResultsList();
		if (resultsList !== null) {
			const updateIds = [resultsList.id];
			this.jsfAjaxScrollImprovements = new JsfAjaxScrollImprovements(
				this.rootElement.ownerDocument,
				{
					getScrollArea: this.getScrollArea,
					onUpdateIds: updateIds,
					selectedItemQuery: ".isStartOfSelectingRange, .isSelected, .ui-state-highlight",
					preferCenteringSelectedIfSourceNotAncestor: true,
					alwaysRememberScrollPosition: false
				}
			);
		}
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		this.jsfAjaxScrollImprovements?.destroy();
	}

	private readonly getSearchResultsList = () => {
		return this.rootElement.querySelector(".searchResultsList");
	}
	private readonly getScrollArea = (): Element | null => {
		const panelLayout = PanelLayout.getInstance(this.rootElement);
		if (panelLayout !== undefined) {
			if (panelLayout.isMainContentOverflowDisabled()) {
				const mainContentElement = panelLayout.getMainContentElement();
				if (mainContentElement !== null) {
					return mainContentElement;
				}
			}
		}

		const resultsArea = this.getSearchResultsList();
		if (resultsArea === null) {
			return null;
		}
		return resultsArea.querySelector(".ui-datalist-content, .ui-datatable-tablewrapper");
	}
}
